import NavbarNew from "../components/layout/NavbarNew";
import FooterNew from "../components/layout/FooterNew";
import HeroSectionNew from "../components/sections/HeroSectionNew";
import { FeaturesSection, StatsSection, CTASection } from "../components/sections/SectionsNew";

export default function PreviewPage() {
  return (
    <div style={{ background: "#06080F", minHeight: "100vh", overflowX: "hidden" }}>
      <NavbarNew />
      <main>
        <HeroSectionNew />
        <FeaturesSection />
        <StatsSection />
        <CTASection />
      </main>
      <FooterNew />
    </div>
  );
}
